"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TablCell = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const lib_1 = require("../../lib");
const TablContext_1 = require("./TablContext");
const react_skeleton_loader_1 = (0, tslib_1.__importDefault)(require("react-skeleton-loader"));
const elements_1 = require("../../elements");
const FlexBox_1 = require("../FlexBox");
function renderSkeleton(inCheckbox = false) {
    return ((0, jsx_runtime_1.jsx)(react_skeleton_loader_1.default, { widthRandomness: 0, width: inCheckbox ? '1rem' : '100%', heightRandomness: 0, height: "100%" }, void 0));
}
const TablCell = (_a) => {
    var { children, className, link, checkbox, skeleton, visibleOnHover, sortDirection, onSortDirectionChange } = _a, rest = (0, tslib_1.__rest)(_a, ["children", "className", "link", "checkbox", "skeleton", "visibleOnHover", "sortDirection", "onSortDirectionChange"]);
    const ctx = (0, react_1.useContext)(TablContext_1.TablContext);
    const inHead = ctx.variant === 'head';
    let child = null;
    if (skeleton) {
        child = renderSkeleton(checkbox);
    }
    else {
        const handleSortChange = () => {
            if (!onSortDirectionChange)
                return;
            switch (sortDirection) {
                case 'ASC':
                    onSortDirectionChange('DESC');
                    break;
                case 'DESC':
                    onSortDirectionChange('ASC');
                    break;
                default:
                    onSortDirectionChange('DESC');
                    break;
            }
        };
        child = ((0, jsx_runtime_1.jsxs)(FlexBox_1.FlexBox, Object.assign({ alignItems: "center", className: onSortDirectionChange ? 'tabl__cell-sort-container' : undefined, onClick: onSortDirectionChange ? handleSortChange : undefined }, { children: [children, sortDirection && ((0, jsx_runtime_1.jsx)(elements_1.Icon, { name: sortDirection === 'ASC' ? 'arrowUp' : 'arrowDown', className: "tabl__cell-sort-icon" }, void 0))] }), void 0));
    }
    const props = Object.assign(Object.assign({}, rest), { children: child, className: (0, lib_1.classnames)((0, lib_1.bem)('tabl__cell', inHead ? '--head' : '--body', (0, lib_1.use)(link, '--link'), (0, lib_1.use)(checkbox, '--checkbox'), (0, lib_1.use)(visibleOnHover, '--visible-on-hover')), className) });
    if (inHead) {
        return (0, jsx_runtime_1.jsx)("th", Object.assign({}, props, { scope: "col" }), void 0);
    }
    else {
        return (0, jsx_runtime_1.jsx)("td", Object.assign({}, props), void 0);
    }
};
exports.TablCell = TablCell;
//# sourceMappingURL=TablCell.js.map